import {
    ajax,
    ajaxP,
    ajaxBack
} from '@/utils/request'

// 车主认证信息
export function verificationInfo() {
    return ajax('api/v1/customerVerifies');
}

// 车主银行卡列表
export function bankList() {
    return ajax('api/v1/customerBankCards');
}

// 新增银行卡
export function bankAdd(params) {
    return ajaxP('api/v1/customerBankCards', params);
}

// 解除绑定银行卡
export function bankDel(params) {
    return ajaxBack({
        url: `api/v1/customerBankCards/${params.bankCardNumber}`,
        method: "DELETE"
    });
}

// 提现
export function exchangeMoney(params) {
    return ajaxP('api/v1/h5/withdrawOrders/application', params);
}

// 提现记录
export function moneyhistory(params) {
    return ajax('api/v1/h5/customers/withdrawOrders', params);
}